module.exports = __webpack_public_path__ + "static/media/download_src_4.056645cf.jpg";